import React from 'react';
import { whyChooseUs } from '../data/mockData';
import { ArrowUpRight } from 'lucide-react';
import * as Icons from 'lucide-react';
import { motion } from 'framer-motion';

const WhyChooseUsSection = ({ onOpenContactForm }) => (
  <section className="py-24 md:py-32 bg-stone-50 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <motion.div initial={{ opacity: 0, x: -80 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }} className="lg:sticky lg:top-28">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 block mb-4">Why Us</span>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-900 leading-tight mb-6">Not Another<br/><span className="italic text-emerald-900">Form-Filling Service.</span></h2>
          <p className="text-stone-500 leading-relaxed mb-8">We're trademark attorneys who've filed thousands of applications. We know what gets approved and what gets rejected — and we build every filing to win.</p>
          <div className="mb-8 overflow-hidden border-2 border-stone-200 shadow-[6px_6px_0px_#d6d3d1]">
            <img src="https://images.unsplash.com/photo-1648712898089-4435bc87b587?w=600&h=350&fit=crop" alt="Contract signing" className="w-full h-48 object-cover" />
          </div>
          <button data-testid="why-choose-cta" onClick={onOpenContactForm}
            className="group inline-flex items-center gap-2 px-8 py-4 bg-emerald-900 text-white font-bold text-sm tracking-wide border-2 border-emerald-900 hover:-translate-y-0.5 hover:shadow-[-6px_6px_0px_#EA580C] transition-all duration-200">
            Work With Us <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-200" />
          </button>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 80 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94], delay: 0.15 }} className="space-y-5">
          {whyChooseUs.map((item, idx) => {
            const Ic = Icons[item.icon];
            return (
              <motion.div key={item.id} initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: 0.2 + idx * 0.1 }}
                data-testid={`why-choose-card-${item.id}`}
                className="group bg-white p-8 border-2 border-stone-200 cursor-default transition-all duration-200 hover:border-stone-900 hover:-translate-y-1 hover:shadow-[6px_6px_0px_#1C1917]">
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 bg-stone-100 border-2 border-stone-200 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-900 group-hover:border-emerald-900 transition-all duration-200">
                    {Ic && <Ic className="w-5 h-5 text-emerald-900 group-hover:text-white transition-colors duration-200" strokeWidth={1.5} />}
                  </div>
                  <div><h3 className="font-sans text-lg font-bold text-stone-900 mb-2">{item.title}</h3><p className="text-sm text-stone-500 leading-relaxed">{item.description}</p></div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </div>
  </section>
);
export default WhyChooseUsSection;
